<div  class="z-10 relative w-full max-w-2xl  p-4 px-10 rounded-lg">
    <div class="text-7xl font-bold leading-none text-gray-100">
        <div>{{"Smiles Manager"}}</div>
        <div class="text-sm text-secondary">{{ SMM_VER_DATA.currentVersion.name}}, {{ SMM_VER_DATA.currentVersion.version}}</div>
        <div class="mt-6 text-lg tracking-tight leading-6 text-gray-400">
            <div class="text-gray-400 prose prose-sm font-medium min-h-[290px]">
                Singura platformă stomatologică cu adevărat modularizată și interconectată unde plătești ce folosești cat folosești.
                Dezvoltată și întreținută de profesioniști cu experiență și simț al responsabilități, <span class="text-green-500"><b>fără vibe coding</b></span>.
                <!--        <div class="grid grid-cols-4 mt-2 w-full justify-items-center gap-2">-->
                <!--            <ng-container *ngFor="let module of allModules">-->
                <!--                <div class="flex flex-col w-full text-sm justify-center items-center"-->
                <!--                     [@fadeIn] [@fadeOut]>-->
                <!--                    <mat-icon class="icon-size-12" [svgIcon]="module.icon"></mat-icon>-->
                <!--                    <div class="w-full text-center">{{module.name}}</div>-->
                <!--                </div>-->
                <!--            </ng-container>-->
                <!--        </div>-->
                <div *ngIf="selectedModule"
                    [@fadeIn] [@fadeOut]
                     class="flex flex-col w-full items-center my-8">
                    <div class="flex flex-row w-full items-center">
                        <mat-icon class="icon-size-8" [svgIcon]="selectedModule.icon"></mat-icon>
                        <div class="w-full text-lg font-bold w-full ml-4">{{selectedModule.name}}</div>
                    </div>
                    <div class="w-full text-sm w-full " [innerHTML]="selectedModule.summary"></div>

                    <div class="grid grid-cols-2 mt-2 text-sm w-full ">
                        <ng-container *ngFor="let feat of selectedModule.functionalities">
                            <div class="flex flex-row items-center w-full">
                                <mat-icon
                                    class="icon-size-5 text-primary"
                                    [svgIcon]="feat.icon"></mat-icon>
                                <div class="ml-2">{{feat.name}}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex items-center mt-8">
        <div *ngIf="showCreatedBy"
            class="flex flex-0 items-center -space-x-1.5">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/male-07.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/female-11.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/male-09.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/female-03.jpg">
        </div>

        <div *ngIf="!showCreatedBy"
            class="flex flex-0 items-center -space-x-1.5">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/male-03.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/female-07.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/male-14.jpg">
            <img
                class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                src="assets/images/avatars/female-06.jpg">
        </div>
        <div class="flex flex-col gap-0 leading-tight w-full ml-4 text-gray-400">
            <div class="grid leading-tight gap-0 font-medium tracking-tight">
                <div class="col-start-1 row-start-1 "
                     *ngIf="showCreatedBy"
                     [@fadeIn] [@fadeOut]>Creata de</div>
                <div class="col-start-1 row-start-1"
                     *ngIf="!showCreatedBy"
                     [@fadeIn] [@fadeOut]>Folosita de</div>
            </div>
            <div class="text-xl font-bold text-gray-400">PROFESIONISTI</div>
        </div>

    </div>
</div>
